<template>
  <div class="thread__footer p-relative">
    <template v-if="isBuilderContext() || isAuthenticated">
      <template v-if="isThread">
        <div class="thread__corner" />
        <div class="thread__line-vert" />
      </template>

      <slot />
    </template>
    <template v-else>
      <v-button ghost block small to="#auth">
        {{
          isCommentThread
            ? "Login to join the conversation"
            : "Login to join chat"
        }}
      </v-button>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex"

import isBuilderContext from "@/lib/is-platform/is-builder-context"

export default {
  props: {
    isCommentThread: { type: Boolean, default: false },
    isThread: { type: Boolean, default: false }
  },

  methods: {
    isBuilderContext
  },

  computed: {
    ...mapGetters("auth", ["isAuthenticated"])
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables";
@import "@/assets/styles/mixins";

.thread__footer {
  @include block-link;

  z-index: 4;
  padding: 0;
  width: 100%;
  width: calc(100% - #{$size--4 * 2});
  max-width: $content--max-width - 32px;
  margin: 0 $size--4;

  .thread__corner {
    top: 0;
  }

  .thread__line-vert {
    position: absolute;
    width: 2px;
    background: $color-ui--grey-20;
    background: linear-gradient(to bottom, rgba(#dde3e9, 0), #dde3e9);
    left: -20px;
    height: 8rem;
    top: -120px;
  }
}
</style>
